import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import Intro from "../components/Intro";
import News from "../components/News";
import Partners from "../components/Partners";
import Gallery from "../components/Gallery";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function Home(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <Intro />
        <News />
        <Partners />
        <Gallery />
        <Footer />
      </div>
    </AppTheme>
  );
}
